var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2101_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 12.6768C18.1 14.5868 16.55 16.1368 14.64 16.1368H13.69C11.78 16.1368 10.23 14.5868 10.23 12.6768C10.23 10.7668 8.68 9.21685 6.77 9.21685H2.18C1.25 9.21685 0.5 9.96685 0.5 10.8968V19.2768C0.5 20.9068 1.82 22.2368 3.46 22.2368H24.87C26.5 22.2368 27.83 20.9168 27.83 19.2768V10.8868C27.83 9.95685 27.08 9.20685 26.15 9.20685H21.56C19.65 9.20685 18.1 10.7568 18.1 12.6668V12.6768Z",
    stroke: "#C94B32",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86035 9.10688V5.23688H26.5904V9.10688",
    stroke: "#C94B32",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4502 4.48685V1.14685H24.7602V4.48685",
    stroke: "#C94B32",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2101_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.33,
    height: 22.08,
    fill: "white",
    transform: "translate(0 0.646851)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archiveIcon.16bdb449a8cc7e65cc44d30b85d56801.svg";
export { ForwardRef as ReactComponent };